import { render, staticRenderFns } from "./DisplaySettingsDialog.vue?vue&type=template&id=4d94d08d&scoped=true"
import script from "./DisplaySettingsDialog.vue?vue&type=script&lang=js"
export * from "./DisplaySettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_babel-core@7.0.0-bridge.0_@babel+core@7.29._923e00a32cb73abfd4273dbca1fa1c77/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94d08d",
  null
  
)

export default component.exports